export const URL_PLACES_API = 'https://maps.googleapis.com/maps/api';
export const URL_RECAPTCHA_VERIFY = 'https://www.google.com/recaptcha/api/siteverify';
export const URL_GOOGLE_PRIVACY_POLICY = 'https://policies.google.com/privacy';
export const URL_GOOGLE_TERMS = 'https://policies.google.com/terms';
